<div [formGroup]="shippingDetailsGroup" class="p-4">
  <h2 class="text-2xl font-semibold mb-4">Shipping Address:</h2>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
    <!-- Left Column -->
    <div class="flex flex-col gap-6">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Street Address 1</mat-label>
        <input matInput formControlName="address1Street" placeholder="Street Address 1" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Street Address Details</mat-label>
        <input matInput formControlName="address1StreetDetails"
               placeholder="Street Address Details" />
      </mat-form-field>
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>City</mat-label>
          <input matInput formControlName="address1City" placeholder="City" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Zip</mat-label>
          <input matInput formControlName="address1Zip" placeholder="Zip" />
        </mat-form-field>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Country</mat-label>
          <mat-select formControlName="address1Country">
            <mat-option value="">Select Country</mat-option>
            <mat-option *ngFor="let country of countries(); trackBy: trackByCountryName"
                        [value]="country.name">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>State/Province</mat-label>
          <input matInput formControlName="address1State" placeholder="State/Province" />
        </mat-form-field>
      </div>
    </div>
    <!-- Right Column -->
    <div class="flex flex-col gap-6">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>ATTN / Dept</mat-label>
        <input matInput formControlName="attn" placeholder="ATTN / Dept" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Shipping Notes</mat-label>
        <textarea matInput formControlName="shippingNotes" placeholder="Shipping Notes"
                  rows="2"></textarea>
      </mat-form-field>
    </div>
  </div>
  <ng-container *ngIf="countries()?.length === 0">
    <div class="text-xs text-gray-500">No countries available.</div>
  </ng-container>

  <ciwc-order-additional-shipments [parentForm]="parentForm"
                                   [orderDetails]="orderDetails"
                                   [countries]="countries()"
                                   [viewDisable]="viewDisable"
                                   [createShipmentGroup]="createShipmentGroup">
  </ciwc-order-additional-shipments>
</div>
